<template>
    <div
        :class="[
            route().current('conversation', {
                user: conversation.participant.username,
            })
                ? 'bg-purple-100 hover:bg-purple-50'
                : 'hover:bg-gray-100',
        ]"
        class="flex px-2 py-3 space-x-3"
    >
        <div class="flex-shrink-0">
            <avatar :user="conversation.participant" class="w-12 h-12" />
        </div>
        <div class="flex flex-1 flex-col space-y-1">
            <div class="flex justify-between space-x-3">
                <div class="flex-1 min-w-0">
                    <Link :href="conversation.url" class="block focus:outline-none" preserve-scroll preserve-state>
                        <div aria-hidden="true" class="absolute z-20 inset-0"></div>
                        <span class="text-gray-800 text-sm font-medium truncate"> {{ conversation.participant.tag }} </span>
                    </Link>
                </div>
                <div class="flex flex-none items-center min-w-0 space-x-2">
                    <!--<time :datetime="message.created_at" class="flex-shrink-0 whitespace-nowrap text-sm text-gray-500">{{ message.time }}</time>-->
                    <span :class="[conversation.readBy[conversation.type] ? 'bg-transparent' : 'bg-purple-500']" class="flex w-3 h-3 rounded-full"></span>
                </div>
            </div>
            <transition name="fade">
                <div v-show="!isTyping" class="absolute top-8 flex items-center mt-1 space-x-1">
                    <span class="max-w-60 text-gray-600 text-sm truncate"> {{ body }} </span>
                    <span class="text-gray-500 font-medium">&middot;</span>
                    <time :datetime="conversation.created_at" class="flex-grow text-gray-500 whitespace-nowrap text-sm">{{ ago }}</time>
                </div>
            </transition>
            <transition name="fade">
                <div v-show="isTyping" class="absolute top-5 flex items-end pl-4 h-5">
                    <div class="dot-falling shadow-dots"></div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import removeMarkdown from "remove-markdown"

export default {
    created() {
        let _this = this
        Echo.private(`conversation.${this.conversation.id}`)
            .listenForWhisper("typing", (e) => {
                this.userTyping = e.userTyping
                this.typing = e.typing

                // remove is typing indicator after 1.2s
                setTimeout(() => {
                    _this.typing = false
                }, 2000)
            })
            .listen(".incoming.message", (e) => {
                this.typing = false
                this.updateConversation(e)
            })
    },

    props: {
        conversation: {
            required: true,
            type: Object,
        },
    },

    data() {
        return {
            typing: false,
        }
    },

    computed: {
        isTyping() {
            if (this.$page.props.conversation && this.conversation === this.$page.props.conversation.id) return false
            return this.typing
        },

        ago() {
            return this.conversation.time === "1s" ? "now" : this.conversation.time
        },

        body() {
            if (!this.conversation.body) return null
            return removeMarkdown(this.conversation.body.text)
            // return this.conversation.body
        },
    },

    methods: {
        updateConversation(conversation) {
            this.$set(this.conversation, "body", conversation.body)
            this.$set(this.conversation, "createdAt", conversation.createdAt)
            this.$set(this.conversation, "time", conversation.time)
            if (this.conversation !== this.$page.props.conversation.id) {
                this.$set(this.conversation, "readBy", conversation.readBy)
            }
        },
    },
}
</script>
